import {useEffect} from 'react';
import {useGetExpressOrderQuery} from 'modules/products/services';
import {
    clearExpressOrderStoreIdCookie,
    getExpressOrderStoreIdFromCookie,
    setExpressOrderStoreIdCookie,
} from 'modules/express-order/helpers/expressOrderStoreCookie';

/**
 * возможно, у пользователя хранится ЭЗ в АПИ, но нет куки
 */
export const useSyncExpressOrderStoreCookie = (): void => {
    const {data, isSuccess} = useGetExpressOrderQuery();

    useEffect(() => {
        if (!isSuccess) {
            return;
        }

        const idVinoteki = data?.data?.idVinoteki;

        if (idVinoteki) {
            const cookieStoreId = getExpressOrderStoreIdFromCookie();

            if (cookieStoreId !== String(idVinoteki)) {
                setExpressOrderStoreIdCookie(idVinoteki);
            }

            return;
        }

        if (getExpressOrderStoreIdFromCookie()) {
            clearExpressOrderStoreIdCookie();
        }
    }, [data, isSuccess]);
};
